import React, { useContext, useEffect, useState } from 'react'
import useGet from '../customHooks/useGet';
import { Pagination, Space, Table } from 'antd';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { InquriyData } from '../data/data';
import SkeletonEnquiries from './SkeletonEnquiries';
import dayjs from 'dayjs';

const Enquiries = () => {
  const { mainLanguage } = useContext(MainLanguageContext);
  const [datas, setDatas] = useState();
  const [tabIndex, setTabIndex] = useState("all")
  const [resget, apiMethodGet] = useGet();
  useEffect(() => {
    apiMethodGet(`enquiries/list/all/${mainLanguage}/10?page=1`);

  }, []);
  const [currentPage, setCurrentPage] = useState(1)


  const onChange = (current, pageSize) => {
    setCurrentPage(current)
    apiMethodGet(`enquiries/list/all/${mainLanguage}/10?page=${current}`);

  };
  useEffect(() => {
    if (!resget.isLoading) {
      setDatas(resget?.data?.data)
    }

  }, [resget.data])



  useEffect(() => {
    if (resget.data) {
      console.log(resget?.data?.data)
      const updatedData = resget?.data?.data?.map((item, index) => ({
        ...item,
        key: `item-${index}`, // Add a unique key to each object
      }));
      setDatas(updatedData);
    }
  }, [resget.data]);


  const handleUpdate = (active) => {
    setCurrentPage(1)
    setTabIndex(active)
    apiMethodGet(`enquiries/list/${active}/${mainLanguage}/10?page=1`);
  }

  const columns = [
    {
      title: 'Id',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Submit Time',
      render: (_, record) => (
        <>
          <div className='w-[150px]'>
            <b>{dayjs(record?.created_at).format('YYYY-MM-DD hh:mm A')}</b>
          </div>
        </>
      ),
    },

    {
      title: 'Client Name',
      render: (_, record) => (
        <>
          <Space className='w-[150px]'>
            {record?.client_name || record?.client_last_name
              ? `${record?.client_name ?? ""} ${record?.client_last_name ?? ""}`
              : "No Name"}

          </Space>
        </>
      ),
    },
    {
      title: 'Client Data',
      render: (_, record) => (
        <>
          <div>
            <b>Email: </b><span>{record?.client_email || 'No Email'}</span>
            <br />
            <b>PN: </b><span>{record?.client_phone || 'No Phone Number'}</span>
          </div>
        </>
      ),
    },
    {
      title: 'Comment',
      dataIndex: 'client_comments',
      key: 'client_comments',
      render: (_, record) => (
        <>
          <div className='w-[130px]'>
            {record.client_comments || "No Comment"}
          </div>
        </>
      ),
    },
    {
      title: 'Comapny Name',
      dataIndex: 'company_name',
      key: 'company_name',
      render: (_, record) => (
        <>
          <div className={`w-[130px] ${record.company_name ? "" : ""} `}>
            {record.company_name || 'No Company Name'}
          </div>
        </>
      ),
    },
    {
      title: ' Type',
      dataIndex: 'form_type',
      key: 'form_type',
      render: (_, record) => (
        <>
          <div className={`w-[130px] ${record.form_type ? "" : ""} `}>
            {record.form_type || 'No Type'}
          </div>
        </>
      ),
    },
    {
      title: ' Data',
      render: (_, record) => (
        <>
          <Space >
            <ul className='w-[350px]'>
              {record?.car_name && <li>Car Name : {record?.car_name}</li>}
              <li>Referer Page Slug : {record?.referer_page_slug || 'None'}</li>
            </ul>
          </Space>
        </>
      ),
    },



  ];

  return (
    <div className=''>
      <div className="bookingPage-left flex items-center">

        <ul className='list flex gap-6 mb-4 max-lg:flex-wrap'>
          {
            InquriyData.map((item, index) => {
              const { label, color, active } = item
              return (
                <li key={index} className={`font-MluvkaBold border-l-2 leading-[1] pl-2 cursor-pointer transition-all duration-300 ease-in-out   ${tabIndex === active ? "text-[#000] active" : "text-[#999]"}`} style={{ borderColor: color }} onClick={() => handleUpdate(active)}>{label}</li>
              )
            })
          }
        </ul>
      </div>
      <div className='relative'>
        {
          resget.isLoading ?
            <SkeletonEnquiries />
            :
            <div>
              <div className='bookingPagepagination overflow-auto'>
                <Table scroll={{ x: 1300 }} dataSource={datas} columns={columns} />
              </div>


              {(datas?.length !== 0 || !resget?.error) && <div className='my-4'>
                <Pagination
                  onChange={onChange}
                  current={currentPage}
                  total={resget.data?.pagination?.total}
                  pageSize={10}
                />
              </div>}
            </div>
        }

      </div>

    </div>
  )
}

export default Enquiries